import { render, staticRenderFns } from "./BusinessVisitsStatus.vue?vue&type=template&id=50c94112&"
import script from "./BusinessVisitsStatus.vue?vue&type=script&lang=ts&"
export * from "./BusinessVisitsStatus.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessVisitsStatus.vue?vue&type=style&index=0&id=50c94112&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports